import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useProjects(query?: { folder_id?: number; q?: string; limit?: number; offset?: number }) {
  return useQuery({
    queryKey: ["projects", query],
    queryFn: () => api.listProjects(query),
    staleTime: 30_000,
  });
}
